import { N200, N300 } from '@atlaskit/theme/colors';
const colorMap = {
  light: {
    textColor: N200,
    separatorColor: N200
  },
  dark: {
    textColor: N300,
    separatorColor: N300
  }
};
export const getColors = mode => {
  return colorMap[mode];
};